/* MDR STUDIOS — comportamenti della home: reveal allo scroll, carosello prodotti, anteprima indice. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  root.classList.add('mdr-js');
  if (document.querySelector('[data-mdr-wordmark]')) root.classList.add('mdr-wm');

  /* ---- reveal ---- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.mdr-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || design || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }


  /* ---- trascinamento col mouse (il dito scorre già da solo) + frecce da tastiera ---- */
  function enableDrag(track) {
    if (track.dataset.mdrDrag) return;
    track.dataset.mdrDrag = '1';
    var down = false, moved = false, pid = null, x0 = 0, s0 = 0, lx = 0, lt = 0, vx = 0;
    function gap() { return parseFloat(window.getComputedStyle(track).columnGap) || 0; }
    function stepW() {
      var it = track.firstElementChild;
      return it ? it.getBoundingClientRect().width + gap() : 0;
    }
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('button, input, select, textarea, [data-gallery-dot]')) return;
      down = true; moved = false; pid = e.pointerId; x0 = lx = e.clientX; s0 = track.scrollLeft; lt = e.timeStamp; vx = 0;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - x0;
      if (!moved) {
        if (Math.abs(dx) < 5) return;
        moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(pid); } catch (_) {}
      }
      var dt = e.timeStamp - lt;
      if (dt > 0) vx = 0.8 * vx + 0.2 * ((e.clientX - lx) / dt);
      lx = e.clientX; lt = e.timeStamp;
      track.scrollLeft = s0 - dx;
    });
    function end(e) {
      if (!down || (e && e.pointerId !== undefined && e.pointerId !== pid)) return;
      down = false;
      try { track.releasePointerCapture(pid); } catch (_) {}
      if (!moved) return;
      track.classList.remove('is-dragging');
      var target = track.scrollLeft - vx * 180;
      var st = stepW();
      if (st > 0) target = Math.round(target / st) * st;
      target = Math.max(0, Math.min(target, track.scrollWidth - track.clientWidth));
      track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
      var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      track.addEventListener('click', block, true);
      window.setTimeout(function () { track.removeEventListener('click', block, true); }, 80);
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * (stepW() || track.clientWidth * 0.8), behavior: reduce ? 'auto' : 'smooth' });
      }
    });
  }

  /* ---- carosello ---- */
  function initRail(rail) {
    if (rail.dataset.mdrReady) return;
    rail.dataset.mdrReady = '1';
    var track = rail.querySelector('[data-rail-track]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    var bar = rail.querySelector('[data-rail-bar]');
    if (!track) return;
    function step() {
      var item = track.querySelector('.mdr-rail__item');
      return item ? item.getBoundingClientRect().width + 8 : track.clientWidth * 0.8;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? track.scrollLeft / max : 0;
      var visible = track.scrollWidth > 0 ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
      if (bar) {
        bar.style.width = (visible * 100) + '%';
        bar.style.transform = 'translateX(' + (p * (1 / visible - 1) * 100) + '%)';
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    enableDrag(track);
    update();
  }

  /* ---- indice: anteprima che segue il cursore ---- */
  function initIndex(sec) {
    if (sec.dataset.mdrReady) return;
    sec.dataset.mdrReady = '1';
    var peek = sec.querySelector('[data-index-peek]');
    if (!peek || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    var img = peek.querySelector('img');
    var x = 0, y = 0, tx = 0, ty = 0, raf = null;
    function loop() {
      x += (tx - x) * 0.16; y += (ty - y) * 0.16;
      peek.style.transform = 'translate3d(' + (x + 28) + 'px,' + (y - 150) + 'px,0) scale(1)';
      raf = (Math.abs(tx - x) > 0.5 || Math.abs(ty - y) > 0.5) ? window.requestAnimationFrame(loop) : null;
    }
    sec.querySelectorAll('[data-index-link]').forEach(function (a) {
      var th = a.querySelector('.mdr-index__thumb img');
      a.addEventListener('mouseenter', function (e) {
        if (th) { img.src = th.currentSrc || th.src; }
        tx = x = e.clientX; ty = y = e.clientY;
        peek.classList.toggle('is-on', !!th);
        if (!raf) raf = window.requestAnimationFrame(loop);
      });
      a.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; if (!raf) raf = window.requestAnimationFrame(loop); });
      a.addEventListener('mouseleave', function () { peek.classList.remove('is-on'); });
    });
  }

  function boot(scope) {
    var s = scope || document;
    initReveal(s);
    s.querySelectorAll('[data-mdr-rail]').forEach(initRail);
    s.querySelectorAll('[data-mdr-index]').forEach(initIndex);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
